import { styled as o, Box as a, Typography as g } from "@mui/material";
import l from "../generic/CloseButton.js";
import x from "../generic/ModalBox.js";
import { INFO_POPUP_TYPE as i } from "../../../constants/popup.js";
import { noForwardProps as b } from "../../../util/styled/index.js";
import * as s from "ramda";
import { jsxs as f, jsx as t, Fragment as w } from "react/jsx-runtime";
const C = o(x, b)`
  ${(r) => {
  switch (r.__type) {
    case i.BLACK:
      return `
          background: rgba(39, 40, 42, 0.95);
          border-radius: 0px;
        `;
    case i.EXPEDITION_PURPLE:
      return `
          background: linear-gradient(
            180deg,
            #181819 0%,
            #352F61 100%
          );
        `;
    case i.PURPLE:
    default:
      return `
          background: linear-gradient(
            0deg,
            rgba(70, 70, 122, 0.95) 0%,
            rgba(70, 70, 122, 0.85) 40%, 
            rgba(24, 24, 27, 0.95) 80%,
            rgba(24, 24, 27, 0.85) 100%
          );
          border-radius: 12px;
        `;
  }
}}
  // ? use inline-block with fit-content to support safari
  display: inline-block;

  // ? make sure it is always in the center without using transform which cause blur text
  height: fit-content;
  width: fit-content;
  position: absolute;
  inset: 0;
  margin: auto;
`, N = o(a)`
  height: 50px;
  width: 100%;
`, P = o(g)`
  font-size: 20px;
  line-height: 1;
`, y = o(l)`
  position: absolute;
  right: 0px;
  top: 0px;
  height: 50px;
`, k = o(a)`
  flex: 1;
  height: calc(100% - 50px);
  overflow: hidden;
  width: 100%;
`, B = o(l)`
  position: absolute;
  right: -4px;
  border-radius: 50%;
  border: 2px white;
  border-style: solid;
  height: 28px;
  padding: 2px;
  width: 28px;
  top: -4px;
  min-width: unset;

  svg {
    color: white;
  }
`, O = (r) => {
  const {
    children: d,
    className: p,
    closeButtonVariant: c = "header",
    name: n,
    open: h,
    type: u,
    onClose: e,
    ...m
  } = r;
  return /* @__PURE__ */ f(C, {
    __type: u,
    className: p,
    closeAfterTransition: !0,
    open: h,
    onClose: e,
    ...m,
    children: [s.isNotNil(e) && /* @__PURE__ */ t(N, {
      className: "Custom-Header",
      children: n && /* @__PURE__ */ t(P, {
        className: "Custom-Name",
        children: n
      })
    }), /* @__PURE__ */ t(k, {
      className: "Custom-Content",
      children: d
    }), s.isNotNil(e) && /* @__PURE__ */ t(w, {
      children: c === "border" ? /* @__PURE__ */ t(B, {
        onClick: e
      }) : /* @__PURE__ */ t(y, {
        onClick: e
      })
    })]
  });
};
export {
  O as default
};
//# sourceMappingURL=InfoPopup.js.map
